import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import api from '../api/client'
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react'

const ConfirmEmailPage: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError('Invalid or missing confirmation link. Please check your email or sign up again.')
      setLoading(false)
      return
    }
    api.auth
      .confirmEmail(token)
      .then(() => {
        setSuccess(true)
        setLoading(false)
        setTimeout(() => navigate('/login'), 3000)
      })
      .catch((err: any) => {
        setError(err?.body?.message || err?.message || 'Failed to confirm email. The link may have expired.')
        setLoading(false)
      })
  }, [searchParams, navigate])

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
          <Loader2 className="h-12 w-12 text-blue-600 animate-spin mx-auto" />
          <p className="mt-4 text-gray-600">Bezig met bevestigen van je e-mailadres...</p>
        </div>
      </div>
    )
  }

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <CheckCircle className="h-12 w-12 text-green-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            E-mail bevestigd
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Je account is geactiveerd. Je wordt doorgestuurd naar de inlogpagina.
          </p>
          <p className="mt-4 text-center">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              Nu inloggen
            </button>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <AlertCircle className="h-12 w-12 text-red-500" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Bevestiging mislukt
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          {error}
        </p>
        <div className="mt-6 text-center space-x-4">
          <button
            type="button"
            onClick={() => navigate('/signup')}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Opnieuw aanmelden
          </button>
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Naar inloggen
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmEmailPage
